import React from 'react';

export default function SummaryHeader() {
    return (
        <div>
            <h3 className="table__header tw-mb-1">{$t('Revenue, expenditure and net position across your projects')}</h3>
            <p className="tw-text-sm tw-text-charcoal-50 tw-mb-0">
                {$t('Budgeted figures for all or selected projects. Each project uses the budget version chosen in the picker.')}
            </p>
        </div>
    );
}
